export function isEnumValue<T extends Record<string, string>>(
  enumObject: T,
  value?: string | null
): value is T[keyof T] {
  if (!value) return false;
  return Object.values(enumObject).includes(value);
}
